export const unreadNotifications = (notifications = []) => {
  const ret = notifications && notifications.length && notifications.map((item) => !item.read).filter(Boolean).length
  return ret
}
